(function () {
  function splitName(value) {
    var parts = (value || '').trim().split(/\s+/).filter(Boolean);
    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ')
    };
  }

  function getReferrerHost() {
    if (!document.referrer) {
      return '';
    }

    try {
      return new URL(document.referrer).hostname.replace(/^www\./, '');
    } catch (error) {
      return '';
    }
  }

  function getQueryParams() {
    var params = new URLSearchParams(window.location.search);
    return {
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      utm_term: params.get('utm_term') || '',
      source: params.get('source') || ''
    };
  }

  function resolveSignupSource(queryParams) {
    var referrerHost = getReferrerHost();
    var currentHost = window.location.hostname.replace(/^www\./, '');
    var explicitSource = (queryParams.source || '').trim();
    var utmSource = (queryParams.utm_source || '').trim();

    if (explicitSource) {
      return explicitSource;
    }

    if (utmSource) {
      return utmSource;
    }

    if (referrerHost && referrerHost !== currentHost) {
      return referrerHost;
    }

    return 'direct';
  }

  function setStatus(statusNode, tone, message) {
    if (!statusNode) {
      return;
    }

    statusNode.textContent = message;
    statusNode.className = 'bd-exit-popup__status is-visible bd-exit-popup__status--' + tone;
  }

  function clearStatus(statusNode) {
    if (!statusNode) {
      return;
    }

    statusNode.textContent = '';
    statusNode.className = 'bd-exit-popup__status';
  }

  function setSubmitting(button, isSubmitting, originalLabel) {
    if (!button) {
      return;
    }

    button.disabled = isSubmitting;
    button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    button.innerHTML = isSubmitting
      ? '<span class="bd-exit-popup__submit-icon" aria-hidden="true">&raquo;</span> Sending now'
      : originalLabel;
  }

  async function submitToKlaviyo(popup, nameValue, emailValue) {
    var queryParams = getQueryParams();
    var parsedName = splitName(nameValue);
    var siteId = (popup.dataset.bdKlaviyoSiteId || '').trim();
    var listId = (popup.dataset.bdKlaviyoListId || '').trim();
    var customSource = (popup.dataset.bdKlaviyoSource || '').trim();
    var popupScope = popup.dataset.bdPopupScope || 'page';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: customSource || 'Exit intent popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: emailValue.trim(),
                first_name: parsedName.firstName || undefined,
                last_name: parsedName.lastName || undefined,
                properties: {
                  form_name: popupScope === 'global' ? 'bd_exit_popup_global' : 'bd_exit_popup_page',
                  popup_scope: popupScope,
                  signup_source: resolveSignupSource(queryParams),
                  source_page_url: window.location.href,
                  source_page_path: window.location.pathname,
                  source_page_title: document.title,
                  referrer: document.referrer || '',
                  klaviyo_capture_source: customSource || 'Exit intent popup',
                  utm_source: queryParams.utm_source,
                  utm_medium: queryParams.utm_medium,
                  utm_campaign: queryParams.utm_campaign,
                  utm_content: queryParams.utm_content,
                  utm_term: queryParams.utm_term
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: listId
            }
          }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(siteId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2026-04-15'
      },
      body: JSON.stringify(payload)
    });
  }

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-bd-exit-form]');

    if (!form) {
      return;
    }

    event.preventDefault();

    var popup = form.closest('.bd-exit-popup');
    var nameInput = form.querySelector('input[name="name"]');
    var emailInput = form.querySelector('input[name="email"]');
    var submitButton = form.querySelector('.bd-exit-popup__submit');
    var statusNode = popup ? popup.querySelector('[data-bd-exit-status]') : null;
    var siteId = popup ? (popup.dataset.bdKlaviyoSiteId || '').trim() : '';
    var listId = popup ? (popup.dataset.bdKlaviyoListId || '').trim() : '';
    var redirectUrl = popup ? (popup.dataset.bdRedirectUrl || '').trim() : '';
    var originalLabel = submitButton ? submitButton.innerHTML : '';

    clearStatus(statusNode);

    if (!popup || !emailInput) {
      return;
    }

    emailInput.style.borderColor = '';

    if (!emailInput.value || emailInput.value.indexOf('@') < 1) {
      emailInput.focus();
      emailInput.style.borderColor = '#B0730F';
      setStatus(statusNode, 'error', 'Enter a valid email address before we send it through.');
      return;
    }

    if (!siteId || !listId || !redirectUrl) {
      setStatus(statusNode, 'error', 'This popup is not fully configured yet. Add the Klaviyo site ID, list ID, and redirect URL.');
      return;
    }

    setSubmitting(submitButton, true, originalLabel);

    try {
      var response = await submitToKlaviyo(popup, nameInput ? nameInput.value : '', emailInput.value);

      if (!response.ok) {
        throw new Error('Klaviyo subscription request failed with status ' + response.status);
      }

      if (window.fbq) {
        window.fbq('track', 'Lead');
      }

      setStatus(statusNode, 'success', 'You are in. Sending you to the next step now...');
      window.location.href = redirectUrl;
    } catch (error) {
      console.error(error);
      setSubmitting(submitButton, false, originalLabel);
      setStatus(statusNode, 'error', 'We could not save your details just yet. Please try again in a moment.');
    }
  });
})();
